module.exports = __webpack_public_path__ + "img/campaign-status-error.08cb53ec.svg";